import { render } from "./user-detail.vue?vue&type=template&id=59e850ca&scoped=true"
import script from "./user-detail.vue?vue&type=script&lang=js"
export * from "./user-detail.vue?vue&type=script&lang=js"

import "./user-detail.vue?vue&type=style&index=0&id=59e850ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e850ca"]])

export default __exports__